module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0729.6a8b17cf.jpg";